import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function numberLengthValidator(min: number, max: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    console.log("CONTROL");
    const value = control.value?.toString() || "";
    const length = value.replace(/\D/g, "").length;
    console.log("VALUE LENGTH VALIDATOR: ", value, length);
    if (length < min || length > max) {
      return {
        numberLength: { intMinLength: min, intMaxLength: max, actual: length },
      };
    }
    return null;
  };
}
